import { Capacitor } from "@capacitor/core";
import * as app from "./implementations/app";
import * as cypress from "./implementations/cypress";
import * as web from "./implementations/web";

/**
 * A common interface for auth handling across web, app, and cypress
 */

let auth = web;
if (process.browser && window.Cypress) {
  auth = cypress;
} else if (Capacitor.isNative) {
  auth = app;
}

const {
  changePassword,
  crossOriginVerification,
  getDecodedIdToken,
  getStoredIdToken,
  isAppReviewer,
  login,
  logout,
  reauthenticate,
  saveAuthToken,
  signup,
  signupAndLogin,
  wasLoggedIn,
} = auth;

// NOTE(AH): I can't find a neater way of doing this
// isAppReviewer is never used from this file
// signup is never used
export {
  changePassword,
  crossOriginVerification,
  getDecodedIdToken,
  getStoredIdToken,
  isAppReviewer,
  login,
  logout,
  reauthenticate,
  saveAuthToken,
  signup,
  signupAndLogin,
  wasLoggedIn,
};
